import styled from "styled-components";

export const TermsPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const TermsPageTable = styled.div`
  background-color: #edf1fc;
  padding: 40px;
  border-radius: 24px;
  color: #17224d;
  gap: 20px;
  max-width: 1400px;
  margin: 40px auto;
  z-index: 10;
  width: 90%;
  height: 100%;
  background-image: url("/assets/bg.png");
`;

export const TermsPageTitle = styled.h1`
  color: #17224d;
  margin-bottom: 30px;
  text-align: center;
`;

export const TermsResultCard = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  font-size: 14px;
  flex-direction: column;
  gap: 20px;
`;

export const TermsResultContent = styled.p`
  font-size: 16px;
  color: #17224d;
  line-height: 1.5;
`;

export const TermsResultLink = styled.a`
  font-size: 16px;
  color: #0066cc;
  text-decoration: none;
  font-weight: bold;
`;
